<template>
  <v-navigation-drawer v-model="mainSidebarOpen" v-if="mainSidebarOpen" 
    fixed    
    touchless
    :temporary="mainMenuIsTemporary"
    width = "400"
    style="z-index: 40;"
    >
    <v-flex class="sbTitle">
        <v-toolbar flat>
      <v-list class="pt-2">
      <v-list-tile  >
        <v-list-tile-content align-center>
        <v-list-tile-title  class="headline">
          <v-layout>
      <v-flex class="pl-2 ">
        Menu
      </v-flex>
          </v-layout>
        </v-list-tile-title>

        </v-list-tile-content>
        <v-list-tile-action align-center>
        <v-btn icon @click.stop="closeMainSidebar">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      </v-list>
        </v-toolbar>
        <v-progress-linear class="mt-0" v-if="loading" color="blue" indeterminate></v-progress-linear>
    </v-flex>

    <v-divider></v-divider>

    <v-flex class="sbContent">

        <v-layout class="pt-2 pl-2" column fill-height >
      <v-flex>
      <v-subheader class="bigSub">Search</v-subheader>
      
      <v-flex class="search pt-3 pb-4">

      <v-list>
      <SearchCollege />
      <SearchDept />
      <SearchRoom />
      <SearchPeople />
      </v-list>
      

      </v-flex>
      <v-divider></v-divider>
      <v-subheader class="pt-3 bigSub">Tools</v-subheader>
      
      <v-list class="pl-4 pt-4">

      <v-list-tile  @click="openRoomCollection" v-if="this.employeeID">
        <v-list-tile-action><v-icon>list</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          Room Collections
        </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>  

      <v-list-tile :to="`/amenities/`" @click="closeDrawers()" v-if="this.employeeID">
        <v-list-tile-action><v-icon>grading</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          Room Amenities
        </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> 



      <br v-if="this.employeeID" /><br v-if="this.employeeID"/>


      <v-list-tile to="" @click="reviewPhotos">
          <v-list-tile-action>
              <v-badge v-if="isSuperUser" overlap color="red" :value="showIndicatorPhotoReview">
                  <template v-slot:badge>
                      <span class="caption">{{showIndicatorPhotoReview}}</span>
                  </template>
                  <v-icon>photo_camera</v-icon>
              </v-badge>
              <v-icon v-else>photo_camera</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
              Room Photos
            </v-list-tile-title>
          </v-list-tile-content>           
      </v-list-tile>

      <br/><br/>


      <br v-if="this.employeeID" /><br v-if="this.employeeID"/>



      <v-list-tile v-if="!$vuetify.breakpoint.xsOnly" @click="openMeasureTool">
        <v-list-tile-action><v-icon>settings_ethernet</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          {{measureOpen ? 'Hide Measure Tool' : 'Measure Tool'}}
        </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="openCustomLabels">
        <v-list-tile-action><v-icon>label</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          Custom Labeling
        </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>      

      <br/><br/>

      <v-list-tile v-if="allowManagerUI || allowOccupantEditorUI" :to="`/roomviewer/`" exact @click="closeDrawers()">
        <v-list-tile-action><v-icon>line_weight</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          Room Viewer
        </v-list-tile-title>
        </v-list-tile-content>         
      </v-list-tile>

      <v-list-tile v-if="allowManagerUI || allowOccupantEditorUI" :to="`/reports/`" exact @click="closeDrawers()">
        <v-list-tile-action><v-icon>class</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          Reports
        </v-list-tile-title>
        </v-list-tile-content>         
      </v-list-tile>



      </v-list>
      </v-flex>
      <v-flex>
      <v-list class="pl-4 switches">
      <v-list-tile v-if="$vuetify.breakpoint.xsOnly" @click="openSettings">
        <v-list-tile-action><v-icon>settings</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title>Settings</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="$vuetify.breakpoint.xsOnly && isSuperUser" @click="openAdmin">
        <v-list-tile-action><v-icon>brightness_auto</v-icon></v-list-tile-action>
        <v-list-tile-content>
        <v-list-tile-title>Admin</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

<!--       <v-btn slot="activator" icon @click="updateOptionsSidebar(true)">
        <v-icon>settings</v-icon>
      </v-btn> -->

      <v-list-tile v-for="(item, index) in bottomItems"
        :to="item.to"
        :key="index"
        class="grey--text text--darken-2">

        <v-list-tile-action>
        <v-icon class="grey--text text--darken">{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
        <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">
          {{ item.title }}
        </v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
      </v-list>
      </v-flex>

        </v-layout>
    </v-flex>
    
  </v-navigation-drawer>
</template>

<script>
    import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
    import SearchPeople from './search/SearchPeople'
    import SearchDept from './search/SearchDept'
    import SearchCollege from './search/SearchCollege'
    import SearchRoom from './search/SearchRoom'

    let MainSidebar = {

        data() {
        return {
      topItems: [
        { title: 'Item 1', icon: 'place', to: '/'},
        { title: 'Item 2', icon: 'playlist_add', to: ''},
        { title: 'Item 3', icon: 'list', to: ''},
        { title: 'Help', icon: 'help_outline', to: '' },
      ],
      bottomItems: [
        { title: 'About Interactive Floorplans', icon: 'live_help', to: '/about'},   
        { title: 'Feedback / Report Bugs', icon: 'feedback', to: '/feedback'},  
        { title: 'Logout', icon: 'exit_to_app', to: '/logout'}      
       ],
        }
        },

        components: { SearchPeople, SearchDept, SearchCollege, SearchRoom },

        computed: {
      ...mapState({
                      stateMainSidebarOpen:     state => state.ui.mainSidebarOpen, 
                      mainMenuIsTemporary:      state => state.ui.mainMenuIsTemporary,        
                      buildings:                state => state.space.buildings,
                      selectedBuilding:         state => state.space.selectedBuilding,
                      loading:                  state => state.search.loading,
                      measureOpen:              state => state.ui.measureOpen,
                      clearGraphics:            state => state.mapFunctions.clearGraphics,
                      isSuperUser:              state => state.user.isSuperUser,
                      useDevDatabase:           state => state.ui.useDevDatabase,
                      employeeID:               state => state.user.userProfile.employeeID,
                      showIndicatorPhotoReview: state => state.ui.showIndicatorPhotoReview,
                      darkTheme:                state => state.ui.darkTheme,
      }),
      ...mapGetters(['allowManagerUI', 'allowOccupantEditorUI', '']),

      mainSidebarOpen: {
      get () {
        return this.stateMainSidebarOpen
      },
      set (value) {
        this.updateMainSidebar(value)
      }
      },
      
/*      measureOpen: {
      get () {
        //console.log("Measue open...")
        //console.log("in the get:: "+this.$store.state.ui.measureOpen)
        return this.$store.state.ui.measureOpen
      },
      set (value) {
        //false
        //console.log("in the set:: "+value)
        return this.$store.state.ui.measureOpen

      }
      },*/
        },

        methods: {
      ...mapActions(['selectBuilding', 'activateMeasure', 'deactivateMeasureTB']),
      ...mapMutations([   'updateMainSidebar', 
                          'updateCollectionSidebar', 
                          'updateSearchResultSidebar', 
                          'setShowBuildingLabels',       
                          'setSearchResults',
                          'setSearchTitle',
                          'setSearchSubtitle',
                          'setSearchSort',      
                          'showMeasure',
                          'setSnackText',
                          'updateLabelSidebar',
                          'updateOptionsSidebar',
                          'updateAdminSidebar',
                          'updateRoomAssociationSidebar',
                          'updateContentSidebar',
                          'updateRoomAmenitySidebarOpen',
                          'setMainMenuIsTemporary',
                          'setShowPhotoReview',
                          'SET_MEASURED_VALS',
                          'SET_MEASURE_DIALOG',                              ]),

      closeMainSidebar() {
        this.updateMainSidebar(false)
        this.setMainMenuIsTemporary(true)   // Search disables temporary.  Explictly closing this restores it
      },

      openRoomCollection() {
      this.updateCollectionSidebar(true)
      this.updateMainSidebar(false)
      },

      openSettings() {
      this.updateOptionsSidebar(true)
      this.updateMainSidebar(false)
      },

      openAdmin() {
      this.updateAdminSidebar(true)
      this.updateMainSidebar(false)
      },

      closeDrawers: function () {
      this.updateAdminSidebar(false)
      this.updateContentSidebar(false)
      this.updateRoomAssociationSidebar(false)
      this.updateMainSidebar(false)
      },

      reviewPhotos: function () {
                this.setShowPhotoReview(true)                
                this.closeDrawers()
            },

      submitBuildingSearch(value) {
        let searchResults = this.buildings
        this.buildingSearchItems.forEach((searchTerm) => {
          if (searchTerm.searchValue) {
          // I could do a case statement here with this one as the default (substring) search.
          // Different comparisons would be needed for Department search of Room Percentage
          searchResults = searchResults.filter((bldg) => bldg[`${searchTerm.apiProp}`].toLowerCase().includes(searchTerm.searchValue.toLowerCase()))
          }
        })

        console.log(searchResults)
        this.setSearchResults(searchResults)
        this.updateSearchResultSidebar(true)
      },

      openMeasureTool () {
        if (this.measureOpen) { this.clearGraphics() }
        console.log('Open measure Tool...!' + this.measureOpen)
        this.showMeasure(!this.measureOpen)
        this.updateMainSidebar(false)      
        if (!this.measureOpen) {
          // console.log("Measure close ")
          this.deactivateMeasureTB()
        } else {
          // console.log("Measure open ")
          //       store.commit("SET_MEASURE_SELECT", {});
          this.activateMeasure('measure-length')
          this.SET_MEASURED_VALS(null)
          this.SET_MEASURE_DIALOG(false)
        }
      
      },

      openCustomLabels() {
      //if (this.measureOpen) { this.clearGraphics() }
      this.updateLabelSidebar(true)
      this.updateMainSidebar(false)
      },

        }
    }

    export default MainSidebar
</script>

<style>

  .sidebar {
    display: flex !important;
    flex-direction: column !important;
    z-index: 200 !important;
  }

  .switches .v-label {
    left: 10px !important;
  }

  .bigSub {
    font-size: 16pt !important;
  }

  .search .v-input__slot {
    padding-left:23px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/MainSidebar.vue